import { TextField } from '@material-ui/core';

export const TextFieldReadOnly = ({
  value,
  label,
  fullWidth
}: {
  value: string;
  label?: string;
  fullWidth?: boolean;
}) => {
  return (
    <TextField
      label={label}
      fullWidth={fullWidth}
      defaultValue={value}
      InputProps={{ readOnly: true, 'aria-readonly': true }}
    />
  );
};
